export * from './resdetindex.component';
